<template>
    <section class="m-blog-single-hero">
        <y-loading
            v-if="!blogData"
            :active="$wait.is('loading-hero-single')"
            size="60"
            height="467px"
            position="relative"
        />
        <div
            v-else
            class="m-blog-single-hero--loaded"
        >
            <div class="single-hero">
                <h1
                    v-if="blogData.title"
                    class="single-hero__title"
                    v-text="blogData.title"
                />
                <div class="single-hero__image-container">
                    <img
                        :src="imgSrc(blogData.header_image, 'main1')"
                        :alt="blogData.title"
                        class="hero-blog-img"
                    >
                </div>
                <div class="single-hero__article-meta">
                    <div class="article-meta">
                        <router-link
                            :to="{name:'blog-author', params:{id:blogData.publisher.id}}"
                            class="article-meta__author"
                        >
                            <div
                                v-if="blogData.publisher && blogData.publisher.avatar && blogData.publisher.avatar.length"
                                class="author-avatar-container"
                            >
                                <img
                                    :src="imgSrc(blogData.publisher.avatar[0])"
                                    :alt="$t('blog.alt.avatar')"
                                    class="author-avatar-img"
                                >
                            </div>
                            <div class="author-info">
                                <p class="author-info__name">
                                    {{ blogData.publisher.name_full }}
                                </p>
                                <p class="author-info__career">
                                    {{ $t('home.articles.author') }}
                                </p>
                            </div>
                        </router-link>
                        <div class="article-meta__info">
                            <div class="meta-info">
                                <span
                                    v-if="blogData.tagging_cats[0] && blogData.tagging_cats[0].title"
                                    class="meta-info__tag"
                                >
                                    {{ blogData.tagging_cats[0].title }}
                                </span>
                                <div
                                    v-if="blogData.tagging_cats[0] && blogData.tagging_cats[0].title"
                                    class="between-border"
                                />
                                <span class="meta-info__publish-time">
                                    {{ convertTimestampToDate(blogData.created_at) }}
                                </span>
                                <span class="between-border" />
                                <span class="meta-info__read-time">
                                    {{ $t('blog.read_text', [ digits(blogData.custom.time, $i18n.locale)]) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script >

    import { date } from '@groot-nodes/helpers/date';
    import { digits } from '@groot-nodes/helpers/number';

    export default {
        name: 'BlogSingleHero',

        /**
         *
         * @inheritDoc
         */
        props: {
            blogData: {
                type: Object,
            },

        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            date,
            digits,
            /**
             * generate new customized date from timestamp
             *
             * @param {*} timestamp
             * @returns {string}
             */
            convertTimestampToDate(timestamp) {
                const localDate = date(timestamp, 'MMMM DD,YYYY', this.$i18n.locale);
                return `${localDate}`;
            },
        },
    };

</script>

<style lang="scss" src="./single-hero.scss"/>
